<template>
  <div class="product-table">
    <b-table
      id="product-tablearea"
      striped
      hover
      foot-clone
      small
      stacked="md"
      head-variant="light"
      primary-key="id"
      :items="state.list"
      :fields="fields"
      :tbody-tr-class="rowClass"
      :sort-by="state.sortBy"
      :sort-desc="state.sortDesc"
      no-local-sorting
      @sort-changed="sortChanged"
    >
      <template #cell(maker)="data">
        <div v-b-tooltip :title="data.value" :style="{ maxWidth: '150px' }" class="ellipsis">
          {{ data.value }}
        </div>
      </template>

      <template #cell(name)="data">
        <div v-b-tooltip :title="data.value" :style="{ maxWidth: '150px' }" class="ellipsis">
          {{ data.value }}
        </div>
      </template>

      <template #cell(synonym)="data">
        <div v-if="data.value">
          <div v-b-tooltip :title="data.value">
            <font-awesome-icon icon="comment-alt" />
          </div>
        </div>
      </template>

      <template #cell(actions)="data">
        <div class="text-nowrap">
          <b-button :to="'view/' + data.item.id" variant="secondary"
            :disabled="data.item.status === 'cancel'">詳細</b-button>

          <b-button :to="'inquiry/' + data.item.id" variant="secondary">問い合わせ</b-button>

          <span v-if="data.item.users === 'my'">
            <b-button :to="'edit/' + data.item.id" variant="primary">編集</b-button>
          </span>

          <span v-if="auth.level >= 2 || (data.item.users === 'my' && data.item.status === 'draft')">
            <b-button @click="onDelete(data.item.id)" variant="danger">削除</b-button>
          </span>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'ProductTable',

  computed: {
    ...mapState({ state: 'products', auth: 'auth' }),
  },

  mounted() {
    this.$store.dispatch('products/searchList', this.state);
  },

  data() {
    return {
      fields: [
        { key: 'id', label: 'シリアルNo.', sortable: true, isRowHeader: true, variant: 'light' },
        {
          key: 'status',
          label: 'ステータス',
          sortable: true,
          formatter: (value, key, item) => {
            const labels = { draft: '下書き', public: '公開中', finish: '済', cancel: '取消' };
            return labels[value];
          },
        },
        {
          key: 'type',
          label: '種別',
          sortable: true,
          formatter: (value) => {
            const labels = { sell: '売りたい', buy: '買いたい' };
            return labels[value];
          },
        },
        { key: 'maker', label: 'メーカー名', sortable: true },
        { key: 'name', label: '商品名', sortable: true },
        { key: 'cas_no', label: 'CAS No.', sortable: true },
        { key: 'fema_no', label: 'FEMA No.', sortable: true },
        { key: 'pieces', label: '入目', sortable: true },
        { key: 'nums', label: '数量', sortable: true },
        { key: 'synonym', label: '' },
        { key: 'actions', label: '操作' },
      ],
    };
  },

  methods: {
    onDelete(id) {
      this.$utils.confirm('製品情報削除', '削除してよろしいですか？', () => {
        this.$store.dispatch('products/deleteItem', id);
      });
    },

    rowClass(item, type) {
      if (!item) {
        return;
      }
      return 'product-status-' + item.status;
    },

    sortChanged(evt) {
      this.$store.dispatch('products/searchList', Object.assign({}, this.state, {
        sortBy: evt.sortBy,
        sortDesc: evt.sortDesc,
      }));
    },
  },
};
</script>

<style scoped>
>>> .product-status-draft {
  color: red;
  text-decoration: none;
}
>>> .product-status-public {
  color: blue;
  text-decoration: none;
}
>>> .product-status-finish {
  color: blue;
  text-decoration: line-through;
}
>>> .product-status-cancel {
  color: black;
  text-decoration: line-through;
}

>>> th {
  white-space: nowrap;
}

>>> .ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
